// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linhaTitulo__MY86m {
  border-bottom: 0.1rem solid #0f2047 !important;
  margin-left: 40px !important;
  width: 80px !important;
  margin-top: -16px !important;
}

.styles_tituloContainer__Y8z-w {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
  margin-top: -28px !important;
}

.styles_titulo__zpw6e {
  font-size: 44px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_iconeSubTitulo__GaRPH {
  font-size: 28px !important;
  color: #0f2047 !important;
  margin: -12px 12px -12px 12px !important;
  padding: 0px !important;
}

.styles_subTitulo__cg4EM {
  font-size: 24px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  padding: 0px !important;
  margin: 0px !important;
}

.styles_backgroundContainer__71HuB {
  background-color: #ffffff;
  margin-top: -50px !important;
  margin-left: 40px !important;
  margin-right: 40px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  padding-bottom: 40px !important;
}

.styles_botaoContainer__Nu0v\\+ {
  display: flex !important;
  align-items: center !important;
  margin-left: 40px !important;
}

.styles_botaoNovo__zUqFa {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  margin-top: 20px !important;
  margin-left: 32% !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}

.styles_botaoNovo__zUqFa:hover {
  transform: scale(0.95) !important;
}

.styles_tituloPopup__fHnlS {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_tituloPopupContainer__4xMpT {
  display: flex !important;
  align-items: center !important;
}

.styles_botoesPopupGeral__OMCUj {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_botaoPopupSalvar__g25MZ {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__g25MZ:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__Somxa {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__Somxa:hover {
  transform: scale(0.95) !important;
}

.styles_txtBuscaTabela__luHRb {
  margin-top: 20px !important;
  margin-left: 32% !important;
}

.styles_iconeBusca__jfhuc {
  color: #18316e !important;
  font-size: 28px !important;
  margin-top: 16px !important;
  margin-left: 240px !important;
}

.styles_iconeTabela__uAwrK {
  color: #0f2047 !important;
  font-size: 28px !important;
  padding: 4px !important;
}

.styles_textoExclusao__AWVUy {
  color: #000000 !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
}

.styles_tituloExclusao__-zQts {
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
  font-size: 44px !important;
}

.styles_botaoPopupExcluir__Ijx1z {
  width: 120px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  margin-right: 7%;
  margin-bottom: 4%;
}

.styles_botaoPopupExcluir__Ijx1z:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelarExclusao__829br {
  width: 120px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  margin-right: 4%;
  margin-bottom: 4%;
}

.styles_botaoPopupCancelarExclusao__829br:hover {
  transform: scale(0.95) !important;
}

.styles_inputPequeno__CFIIW {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adicione mais estilos conforme necessário */
}



.styles_caixaDeTexto__kFFcy {
  margin: 200px 70 !important; 
  height: 30px !important;
}




.styles_botaoVoltar__Qog6Y {
  background-color: #0f2047;
  color: #ffffff;
  border-color: #ffffff;
  border-width: 1px;
  border-style: solid;
  font-family: "Inter";
  border-radius: 8px;
  transition: all 0.3s ease;
  text-transform: capitalize;
  height: 36px;
}

.styles_botaoVoltar__Qog6Y:hover {
  background-color: #0f2047;
  color: #ffffff;
}


.styles_labelPequeno__QIB-P {
  font-size: 12px; /* Ajuste o valor conforme necessário */
}

.styles_placeholder__M6Nut {
  font-size: 12px; /* Ajuste o valor conforme necessário */
  /* Outros estilos do placeholder, se necessário */
}

.styles_bordaInferior__O4qgj {
  border-bottom: 1px solid #000; /* Cor e largura da borda inferior */
  border-radius: 0; /* Remove a borda arredondada */
}

`, "",{"version":3,"sources":["webpack://./src/pages/Folhas/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;;;AAIA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;;;;AAKA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,eAAe,EAAE,uCAAuC;EACxD,iDAAiD;AACnD;;AAEA;EACE,6BAA6B,EAAE,oCAAoC;EACnE,gBAAgB,EAAE,+BAA+B;AACnD","sourcesContent":[".linhaTitulo {\n  border-bottom: 0.1rem solid #0f2047 !important;\n  margin-left: 40px !important;\n  width: 80px !important;\n  margin-top: -16px !important;\n}\n\n.tituloContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n  margin-top: -28px !important;\n}\n\n.titulo {\n  font-size: 44px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.iconeSubTitulo {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  margin: -12px 12px -12px 12px !important;\n  padding: 0px !important;\n}\n\n.subTitulo {\n  font-size: 24px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.backgroundContainer {\n  background-color: #ffffff;\n  margin-top: -50px !important;\n  margin-left: 40px !important;\n  margin-right: 40px !important;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n  padding-bottom: 40px !important;\n}\n\n.botaoContainer {\n  display: flex !important;\n  align-items: center !important;\n  margin-left: 40px !important;\n}\n\n.botaoNovo {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  margin-top: 20px !important;\n  margin-left: 32% !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}\n\n.botaoNovo:hover {\n  transform: scale(0.95) !important;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.txtBuscaTabela {\n  margin-top: 20px !important;\n  margin-left: 32% !important;\n}\n\n.iconeBusca {\n  color: #18316e !important;\n  font-size: 28px !important;\n  margin-top: 16px !important;\n  margin-left: 240px !important;\n}\n\n.iconeTabela {\n  color: #0f2047 !important;\n  font-size: 28px !important;\n  padding: 4px !important;\n}\n\n.textoExclusao {\n  color: #000000 !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n}\n\n.tituloExclusao {\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n  font-size: 44px !important;\n}\n\n.botaoPopupExcluir {\n  width: 120px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  margin-right: 7%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupExcluir:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelarExclusao {\n  width: 120px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n  margin-right: 4%;\n  margin-bottom: 4%;\n}\n\n.botaoPopupCancelarExclusao:hover {\n  transform: scale(0.95) !important;\n}\n\n.inputPequeno {\n  width: 100%;\n  padding: 5px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  /* Adicione mais estilos conforme necessário */\n}\n\n\n\n.caixaDeTexto {\n  margin: 200px 70 !important; \n  height: 30px !important;\n}\n\n\n\n\n.botaoVoltar {\n  background-color: #0f2047;\n  color: #ffffff;\n  border-color: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  font-family: \"Inter\";\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n  height: 36px;\n}\n\n.botaoVoltar:hover {\n  background-color: #0f2047;\n  color: #ffffff;\n}\n\n\n.labelPequeno {\n  font-size: 12px; /* Ajuste o valor conforme necessário */\n}\n\n.placeholder {\n  font-size: 12px; /* Ajuste o valor conforme necessário */\n  /* Outros estilos do placeholder, se necessário */\n}\n\n.bordaInferior {\n  border-bottom: 1px solid #000; /* Cor e largura da borda inferior */\n  border-radius: 0; /* Remove a borda arredondada */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linhaTitulo": `styles_linhaTitulo__MY86m`,
	"tituloContainer": `styles_tituloContainer__Y8z-w`,
	"titulo": `styles_titulo__zpw6e`,
	"iconeSubTitulo": `styles_iconeSubTitulo__GaRPH`,
	"subTitulo": `styles_subTitulo__cg4EM`,
	"backgroundContainer": `styles_backgroundContainer__71HuB`,
	"botaoContainer": `styles_botaoContainer__Nu0v+`,
	"botaoNovo": `styles_botaoNovo__zUqFa`,
	"tituloPopup": `styles_tituloPopup__fHnlS`,
	"tituloPopupContainer": `styles_tituloPopupContainer__4xMpT`,
	"botoesPopupGeral": `styles_botoesPopupGeral__OMCUj`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__g25MZ`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__Somxa`,
	"txtBuscaTabela": `styles_txtBuscaTabela__luHRb`,
	"iconeBusca": `styles_iconeBusca__jfhuc`,
	"iconeTabela": `styles_iconeTabela__uAwrK`,
	"textoExclusao": `styles_textoExclusao__AWVUy`,
	"tituloExclusao": `styles_tituloExclusao__-zQts`,
	"botaoPopupExcluir": `styles_botaoPopupExcluir__Ijx1z`,
	"botaoPopupCancelarExclusao": `styles_botaoPopupCancelarExclusao__829br`,
	"inputPequeno": `styles_inputPequeno__CFIIW`,
	"caixaDeTexto": `styles_caixaDeTexto__kFFcy`,
	"botaoVoltar": `styles_botaoVoltar__Qog6Y`,
	"labelPequeno": `styles_labelPequeno__QIB-P`,
	"placeholder": `styles_placeholder__M6Nut`,
	"bordaInferior": `styles_bordaInferior__O4qgj`
};
export default ___CSS_LOADER_EXPORT___;
